"use server";

import { Product } from "../types/search";
import { serverRepo } from "../apis/server_repo";
import { RnrPortalsJson } from "../types/client";
import { getRequestEvent } from "solid-js/web";

export type WebStoreRouteData = {
  brands: Product[];
  rnrPortalsJson?: RnrPortalsJson;
};

export const getStoreRouteData = async (): Promise<WebStoreRouteData> => {
  const result = await serverRepo.getProductSearch({
    query: "",
    pagination: { pageNo: 0, limit: 30 },
  });

  const requestEvent = getRequestEvent();

  const brands: Product[] = [];
  result.data.forEach((section) => {
    section.products.forEach((product) => {
      if (product.voucherProduct.status === "ACTIVE") {
        brands.push(product);
      }
    });
  });

  const rnrPortalsJson = requestEvent?.locals?.rnrPortalsJson;

  return {
    brands,
    ...(rnrPortalsJson && { rnrPortalsJson }),
  };
};
